import React, {useState} from 'react';
import cx from 'classnames';

import {
    Icon,
    IconTypes,
    InteractiveElement,
    ThemeConsumer,
} from '../../../exports';

export const Chevron: React.FC<
    Partial<React.ComponentProps<typeof Icon>> & {isPointingUpwards: boolean}
> = ({isPointingUpwards, ...props}) => (
    <ThemeConsumer>
        {({colorScheme}) => (
            <Icon
                colorScheme={colorScheme}
                size="small"
                source={
                    isPointingUpwards
                        ? IconTypes.IconChevronUp
                        : IconTypes.IconChevronDown
                }
                {...props}
            />
        )}
    </ThemeConsumer>
);

export const Summary: React.FC<
    React.ComponentProps<typeof InteractiveElement> & {
        isOpen: boolean;
    }
> = ({children, isOpen, ...props}) => (
    <InteractiveElement aria-expanded={isOpen} htmlTag="summary" {...props}>
        {children}
        <Chevron isPointingUpwards={isOpen} />
    </InteractiveElement>
);

export const Details: React.FC<
    Omit<
        React.ComponentProps<typeof Summary>,
        'content' | 'isOpen' | 'onToggle'
    > & {
        content: React.ReactNode;
        isFullWidth?: boolean;
        isInitiallyOpen?: boolean;
        onToggle?: (ev: React.ToggleEvent<HTMLDetailsElement>) => void;
        summaryElement?: typeof Summary;
    }
> = ({
    children,
    className,
    content,
    isFullWidth,
    isInitiallyOpen,
    onToggle,
    summaryElement: SummaryElement = Summary,
    ...props
}) => {
    const [isOpen, setOpen] = useState(isInitiallyOpen ?? false);

    return (
        <details
            onToggle={ev => {
                setOpen(ev.currentTarget.open);
                onToggle?.(ev);
            }}
            open={isOpen}
        >
            <SummaryElement
                className={cx(
                    'd-flex align-items-center',
                    {
                        'justify-content-space-between': isFullWidth,
                    },
                    className,
                )}
                isOpen={isOpen}
                {...props}
            >
                {children}
            </SummaryElement>
            {content}
        </details>
    );
};
